import {cloneDeep} from 'lodash-es';

export const AUDIO_RECORDER_EXT_PROFILE_KEY = 'ext_audio_recorder_ready';

const audioRecorderLongLabelFr = `<p>Ce sondage comprend des <strong>questions au format audio</strong>, pour lesquelles vous devrez enregistrer de courtes réponses à l'aide d'un micro (ordinateur ou téléphone).</p></br><p>Êtes-vous toujours <strong>intéressé(e) à participer</strong> à ce sondage et avez-vous accès à un <strong>micro fonctionnel</strong> ?</p>`;

const audioRecorderLongLabelEn = `<p>This survey includes <strong>audio-format questions</strong>, for which you will need to record short responses using a microphone (on your computer or phone).</p></br><p>Are you still <strong>interested in participating</strong> in this survey, and do you have access to a <strong>working microphone</strong>?</p>`;

// Plain text versions
export const AUDIO_RECORDER_CONFIRMATION_QUESTION_FR = 'Êtes-vous toujours intéressé(e) à participer à ce sondage et avez-vous accès à un micro fonctionnel ?';
export const AUDIO_RECORDER_CONFIRMATION_QUESTION_EN = 'Are you still interested in participating in this survey, and do you have access to a working microphone?';

export const AUDIO_RECORDER_EXT_PROFILE_DEFINITION = Object.freeze({
  keyname: AUDIO_RECORDER_EXT_PROFILE_KEY,
  data: {
    keyName: AUDIO_RECORDER_EXT_PROFILE_KEY,
    keyDef: 'SelectBt',
    randomAssignement: false,
    label: {
      fr: 'Acc&egrave;s &agrave; un micro fonctionnel',
      en: 'Access to a working microphone',
    },
    longLabel: {
      fr: audioRecorderLongLabelFr,
      en: audioRecorderLongLabelEn,
    },
    params: [
      {
        key: 'oui_jai_acces_a_un_micro_et_je_peux_enregistrer',
        label: {
          fr: "Oui, je suis toujours intéressé(e) et j'ai accès à un micro",
          en: 'Yes, I am still interested and I have access to a microphone',
        },
      },
      {
        key: 'non_je_ne_suis_plus_interesse_ou_pas_acces_a_un_micro',
        label: {
          fr: "Non, je ne suis plus intéressé(e) ou je n'ai pas accès à un micro",
          en: 'No, I am no longer interested or I do not have access to a microphone',
        },
      },
    ],
  },
});

export function cloneAudioRecorderExtProfileDefinition() {
  return cloneDeep(AUDIO_RECORDER_EXT_PROFILE_DEFINITION);
}

// Screenout message for audio requirement failure
export const AUDIO_SCREENOUT_MESSAGE = {
  id: 'audio_screenout_message',
  title: {
    fr: 'Accès au micro impossible',
    en: 'Microphone Access Impossible',
  },
  content: {
    fr: `<div style="display: flex; align-items: center; margin-bottom: 16px;">
  <span style="color: #ef4444; font-size: 24px; margin-right: 12px; line-height: 1;">✕</span>
  <h2 style="font-size: 1.25rem; font-weight: bold; margin: 0;">Accès au micro impossible</h2>
</div>
<p><strong>Merci pour votre intérêt !</strong></p>
<p>Votre navigateur bloque actuellement l'accès au micro pour notre site, ce qui empêche la vérification audio nécessaire à cette étude.</p>
<div style="display: flex; align-items: flex-start; margin: 16px 0;">
  <span style="font-size: 24px; margin-right: 12px; line-height: 1;">👉</span>
  <div>
    <p style="margin: 0; font-weight: bold;">Ce n'est pas permanent.</p>
    <p style="margin: 4px 0 0 0;">Vous pouvez réactiver l'accès au micro dans les paramètres du site de votre navigateur.</p>
  </div>
</div>
    <div style="display: flex; align-items: flex-start; margin: 16px 0;">
      <span style="font-size: 20px; margin-right: 12px; line-height: 1.5;">🔧</span>
      <div style="flex: 1;">
        <p style="margin: 0; font-weight: bold;">Comment faire :</p>
        <ol style="margin: 8px 0; padding-left: 20px; list-style-type: decimal; display: block;">
          <li style="margin-bottom: 8px; display: list-item;">Ouvrez les <strong>paramètres du site</strong> (icône ou bouton près de la barre d'adresse — parfois un cadenas, un curseur ou un "i").</li>
          <li style="margin-bottom: 8px; display: list-item;">Trouvez l'option <strong>Microphone</strong>.</li>
          <li style="margin-bottom: 8px; display: list-item;">Changez « <strong>Bloqué</strong> » pour « <strong>Autoriser</strong> ».</li>
        </ol>
      </div>
    </div>
<p style="margin-top: 16px;">Vous pourrez alors participer à de futures études incluant des questions audio.</p>`,
    en: `<div style="display: flex; align-items: center; margin-bottom: 16px;">
  <span style="color: #ef4444; font-size: 24px; margin-right: 12px; line-height: 1;">✕</span>
  <h2 style="font-size: 1.25rem; font-weight: bold; margin: 0;">Microphone Access Impossible</h2>
</div>
<p><strong>Thank you for your interest!</strong></p>
<p>Your browser is currently blocking microphone access for our site, which prevents the audio verification necessary for this study.</p>
<div style="display: flex; align-items: flex-start; margin: 16px 0;">
  <span style="font-size: 24px; margin-right: 12px; line-height: 1;">👉</span>
  <div>
    <p style="margin: 0; font-weight: bold;">This is not permanent.</p>
    <p style="margin: 4px 0 0 0;">You can re-enable microphone access in your browser's site settings.</p>
  </div>
</div>
    <div style="display: flex; align-items: flex-start; margin: 16px 0;">
      <span style="font-size: 20px; margin-right: 12px; line-height: 1.5;">🔧</span>
      <div style="flex: 1;">
        <p style="margin: 0; font-weight: bold;">How to:</p>
        <ol style="margin: 8px 0; padding-left: 20px; list-style-type: decimal; display: block;">
          <li style="margin-bottom: 8px; display: list-item;">Open your browser's <strong>site settings</strong> (an icon or button near the address bar — sometimes a padlock, a slider, or an "i").</li>
          <li style="margin-bottom: 8px; display: list-item;">Find the <strong>Microphone</strong> option.</li>
          <li style="margin-bottom: 8px; display: list-item;">Change "<strong>Blocked</strong>" to "<strong>Allow</strong>".</li>
        </ol>
      </div>
    </div>
<p style="margin-top: 16px;">You'll then be able to participate in future studies that include audio questions.</p>`,
  },
  type: 'screenOut' as const,
};
